import React from 'react';
import Reveal from './Reveal';
import Eyebrow from './Eyebrow';
import { manifesto } from '../data/content';

const Manifesto = () => {
  return (
    <section id="story" className="relative scroll-mt-20 snap-start py-24 md:py-32">
      <div className="container grid grid-cols-1 gap-12 md:grid-cols-[1.4fr_0.9fr] md:items-start">
        <div>
          <Reveal>
            <Eyebrow>{manifesto.eyebrow}</Eyebrow>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="mb-8 max-w-xl text-[clamp(2rem,3.6vw,3rem)] font-bold tracking-tight">
              {manifesto.heading}
            </h2>
          </Reveal>
          <div className="flex flex-col gap-4">
            {manifesto.paragraphs.map((p, i) => (
              <Reveal key={i} delay={0.1 + i * 0.08}>
                <p className="max-w-[62ch] text-[1.08rem] leading-[1.85] text-muted">{p}</p>
              </Reveal>
            ))}
          </div>
        </div>

        <Reveal delay={0.15} className="flex flex-col gap-4 md:sticky md:top-28">
          <div className="relative aspect-[4/5] overflow-hidden rounded-3xl border border-border">
            <div className="absolute inset-0 z-10 bg-gradient-to-b from-primary/15 via-transparent to-background/40 mix-blend-multiply" />
            <img src={manifesto.portrait} alt="Shubh Joshi" className="h-full w-full object-cover" />
          </div>
          <blockquote className="border-l-2 border-primary-light py-1 pl-4 font-display text-lg italic leading-snug text-foreground">
            {manifesto.quote}
          </blockquote>
        </Reveal>
      </div>
    </section>
  );
};

export default Manifesto;
